var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "background-simple",
    "data-motion": "blob",
    "data-delay": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.45,118.71l-2.44-4C431.5,80.89,394.4,60.51,355.3,63a100.72,100.72,0,0,0-15,2.05C304.77,72.65,273.83,99.54,261,134c-7.54,20.25-9.64,43.57-24,59.65-18.62,20.92-50.25,21.57-78,20.71s-59.45-.13-78,20.87c-11.61,13.16-15.3,31.87-14.36,49.48,2.48,46.64,35,88.35,76.31,109.08s90,22.58,135.23,13.46c63.37-12.77,123.64-47.85,159.86-102S483.43,177.19,454.45,118.71Z",
    style: {
      fill: "#F0F5FA"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "floor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.89,476c0,.15-98,.26-218.88.26s-218.9-.11-218.9-.26,98-.26,218.9-.26S468.89,475.83,468.89,476Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "window-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.25,
    y: 270.73,
    width: 96.76,
    height: 63.81,
    rx: 5.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.13,334.55s.27,0,.8-.09a5.58,5.58,0,0,0,2.18-.79,5.94,5.94,0,0,0,2.41-2.84c.61-1.4.35-3.19.4-5.15,0-7.88-.05-19.27-.09-33.33,0-3.52,0-7.2,0-11,0-1,0-1.93,0-2.91a16.63,16.63,0,0,0-.12-2.92,5.67,5.67,0,0,0-3.71-4.21,8.15,8.15,0,0,0-3-.32H329.68l-60.53,0a5.64,5.64,0,0,0-5.51,4.45,9.3,9.3,0,0,0-.13,1.92v21.36c0,10.12,0,19.89,0,29.19a6.44,6.44,0,0,0,.6,3.27,5.65,5.65,0,0,0,2.21,2.36,5.73,5.73,0,0,0,3.11.77h16.16l23,0,33.33.08,9.06.05,2.36,0,.8,0-.8,0-2.36,0-9.06,0-33.33.08-23,0H269.41a6.32,6.32,0,0,1-3.35-.83,6.17,6.17,0,0,1-2.4-2.56,7,7,0,0,1-.65-3.48c0-9.3,0-19.07,0-29.19q0-7.61,0-15.45v-5.91a9.38,9.38,0,0,1,.14-2,6.17,6.17,0,0,1,6-4.86l60.53,0,13.59,0H353a8.72,8.72,0,0,1,3.16.35,6.1,6.1,0,0,1,4,4.54,17,17,0,0,1,.12,3v2.91c0,3.84,0,7.52,0,11,0,14.06-.06,25.45-.08,33.33,0,1,0,1.91,0,2.79a6.25,6.25,0,0,1-.45,2.42,6,6,0,0,1-2.5,2.87,5.4,5.4,0,0,1-2.23.75A4.81,4.81,0,0,1,354.13,334.55Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.62,
    y: 307.79,
    width: 3.71,
    height: 14.78,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.61,
    y: 305.65,
    width: 3.71,
    height: 16.92,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.36,
    y: 302.12,
    width: 3.71,
    height: 20.44,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.11,
    y: 303.24,
    width: 3.71,
    height: 19.32,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.87,
    y: 296.7,
    width: 3.71,
    height: 25.86,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.37,
    y: 296.83,
    width: 3.71,
    height: 25.73,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.13,
    y: 305.28,
    width: 3.71,
    height: 17.28,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.88,
    y: 297.96,
    width: 3.71,
    height: 24.6,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.63,
    y: 292.42,
    width: 3.71,
    height: 30.14,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.39,
    y: 297.84,
    width: 3.71,
    height: 24.73,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.92,279.52a2.34,2.34,0,1,1-2.34-2.34A2.34,2.34,0,0,1,275.92,279.52Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,279.52a2.34,2.34,0,1,1-2.33-2.34A2.33,2.33,0,0,1,282,279.52Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,279.52a2.34,2.34,0,1,1-2.34-2.34A2.34,2.34,0,0,1,288,279.52Z",
    style: {
      fill: "#DCE7F1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "window-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.16,
    y: 133.02,
    width: 82.52,
    height: 128.88,
    rx: 8.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.25,261.9l.27,0c.17,0,.44,0,.78-.07a8.71,8.71,0,0,0,2.91-.95,8.57,8.57,0,0,0,3.44-3.52,8.4,8.4,0,0,0,.9-3c.08-1.13,0-2.36,0-3.65,0-10.34-.05-25.29-.09-43.75s0-40.47-.05-64.89a8.27,8.27,0,0,0-4-7.59c-2.64-1.7-6-1-9.14-1.16H388.59a8.19,8.19,0,0,0-7.74,5.56,15.58,15.58,0,0,0-.43,5.08v5.16q0,10.3,0,20.28c0,13.29,0,26.11,0,38.32s0,23.82,0,34.68v8c0,1.3-.05,2.63,0,3.87a8.24,8.24,0,0,0,7,7.37,30,30,0,0,0,3.55.1h3.51l43.75.09,11.89.05,3.1,0,1.05,0s-.36,0-1.05,0l-3.1,0-11.89.05-43.75.08H391a33.65,33.65,0,0,1-3.6-.1,8.62,8.62,0,0,1-7.36-7.71c-.08-1.32,0-2.59,0-3.91,0-2.62,0-5.29,0-8,0-10.86,0-22.46,0-34.68s0-25,0-38.32v-28a8.77,8.77,0,0,1,.46-2.64,8.62,8.62,0,0,1,3.15-4.27,8.73,8.73,0,0,1,5.08-1.65h65.47a8.74,8.74,0,0,1,7.88,4.68,9.28,9.28,0,0,1,.8,2.23,11.59,11.59,0,0,1,.18,2.34c0,24.42,0,46.41-.06,64.89s-.06,33.41-.08,43.75c0,1.29,0,2.5-.06,3.66a8.28,8.28,0,0,1-.93,3.09,8.68,8.68,0,0,1-3.53,3.53,8.22,8.22,0,0,1-3,.91A7.52,7.52,0,0,1,454.25,261.9Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.28,
    cy: 144.07,
    r: 2.53,
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.34,144.07a2.53,2.53,0,1,1-2.53-2.53A2.53,2.53,0,0,1,400.34,144.07Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.34,
    cy: 144.07,
    r: 2.53,
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.61,157.35c0,.14-13.07.26-29.19.26s-29.2-.12-29.2-.26,13.07-.26,29.2-.26S450.61,157.2,450.61,157.35Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.61,162.49c0,.14-13.07.26-29.19.26s-29.2-.12-29.2-.26,13.07-.26,29.2-.26S450.61,162.34,450.61,162.49Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.61,167.63c0,.14-13.07.26-29.19.26s-29.2-.12-29.2-.26,13.07-.26,29.2-.26S450.61,167.48,450.61,167.63Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.61,172.77c0,.14-13.07.26-29.19.26s-29.2-.12-29.2-.26,13.07-.27,29.2-.27S450.61,172.62,450.61,172.77Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.61,177.9c0,.15-13.07.26-29.19.26s-29.2-.11-29.2-.26,13.07-.26,29.2-.26S450.61,177.76,450.61,177.9Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.61,183c0,.15-13.07.26-29.19.26s-29.2-.11-29.2-.26,13.07-.26,29.2-.26S450.61,182.9,450.61,183Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.61,222.37c0,.14-13.07.26-29.19.26s-29.2-.12-29.2-.26,13.07-.26,29.2-.26S450.61,222.22,450.61,222.37Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.61,228c0,.14-13.07.26-29.19.26s-29.2-.12-29.2-.26,13.07-.26,29.2-.26S450.61,227.82,450.61,228Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.61,233.56c0,.14-13.07.26-29.19.26s-29.2-.12-29.2-.26,13.07-.26,29.2-.26S450.61,233.41,450.61,233.56Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.61,239.15c0,.14-13.07.26-29.19.26s-29.2-.12-29.2-.26,13.07-.26,29.2-.26S450.61,239,450.61,239.15Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.61,244.74c0,.15-13.07.27-29.19.27s-29.2-.12-29.2-.27,13.07-.26,29.2-.26S450.61,244.6,450.61,244.74Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.13,190.48h-4.55l-12.56,0-42.68,0,.1-.07c0,3.35,0,6.83,0,10.39s0,7.25,0,10.71l-.1-.08,42.38,0,12.46,0h0l-12.46,0-42.38,0h-.1v-.07c0-3.46,0-7,0-10.71s0-7,0-10.39v-.08h.1l42.68,0,12.56,0h4.55Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.13,194s-13.39.08-29.9.08-29.89,0-29.89-.08,13.38-.08,29.89-.08S452.13,194,452.13,194Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.13,196.94s-13.39.07-29.9.07-29.89,0-29.89-.07,13.38-.08,29.89-.08S452.13,196.89,452.13,196.94Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.13,199.84s-13.39.08-29.9.08-29.89,0-29.89-.08,13.38-.07,29.89-.07S452.13,199.8,452.13,199.84Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.13,202.75s-13.39.07-29.9.07-29.89,0-29.89-.07,13.38-.08,29.89-.08S452.13,202.71,452.13,202.75Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.13,205.65s-13.39.08-29.9.08-29.89,0-29.89-.08,13.38-.07,29.89-.07S452.13,205.61,452.13,205.65Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.34,208.56s13.38-.08,29.89-.08,29.9,0,29.9.08-13.39.08-29.9.08S392.34,208.6,392.34,208.56Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.81,211.9s-.07-4.8-.07-10.71,0-10.71.07-10.71.08,4.79.08,10.71S400.86,211.9,400.81,211.9Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.42,211.9s-.07-4.8-.07-10.71,0-10.71.07-10.71.08,4.79.08,10.71S409.47,211.9,409.42,211.9Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,211.9c-.05,0-.08-4.8-.08-10.71s0-10.71.08-10.71.07,4.79.07,10.71S418.08,211.9,418,211.9Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.65,211.9s-.08-4.8-.08-10.71,0-10.71.08-10.71.07,4.79.07,10.71S426.69,211.9,426.65,211.9Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.26,211.9c-.05,0-.08-4.8-.08-10.71s0-10.71.08-10.71.07,4.79.07,10.71S435.3,211.9,435.26,211.9Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.59,211.9s-.08-4.8-.08-10.71,0-10.71.08-10.71.08,4.79.08,10.71S443.63,211.9,443.59,211.9Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.2,211.9s-.07-4.8-.07-10.71,0-10.71.07-10.71.08,4.79.08,10.71S452.24,211.9,452.2,211.9Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.34,208.56a.52.52,0,0,1-.53.52.52.52,0,1,1,0-1A.52.52,0,0,1,401.34,208.56Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.42,
    cy: 202.75,
    r: 0.52,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.56,205.6a.53.53,0,1,1-1.05,0,.53.53,0,0,1,1.05,0Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.12,199.48a.54.54,0,0,1-.77.77h0A.54.54,0,0,1,427.12,199.48Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.83,199.48a.54.54,0,0,1-.77.77h0A.54.54,0,0,1,435.83,199.48Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,205.19a.54.54,0,0,1-.76.77h0A.54.54,0,0,1,444,205.19Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,196.94a.53.53,0,0,1-1.05,0,.53.53,0,1,1,1.05,0Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.34,205.65a.53.53,0,0,1-.53.53.52.52,0,0,1-.52-.53.52.52,0,0,1,.52-.52A.52.52,0,0,1,401.34,205.65Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,208.18a.54.54,0,0,1-.77.76A.54.54,0,0,1,444,208.18Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.78,202.75a.52.52,0,0,1-.52.52.52.52,0,0,1-.53-.52.53.53,0,0,1,.53-.53A.52.52,0,0,1,435.78,202.75Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.26,202.67a.53.53,0,0,1-.53.53.52.52,0,0,1-.52-.53.52.52,0,0,1,.52-.52A.52.52,0,0,1,427.26,202.67Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.22,214a4.35,4.35,0,0,1-1.66,0,4.35,4.35,0,0,1,1.66,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,214a4.35,4.35,0,0,1-1.66,0,4.35,4.35,0,0,1,1.66,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.82,214a4.35,4.35,0,0,1-1.66,0,4.35,4.35,0,0,1,1.66,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.62,214a4.35,4.35,0,0,1-1.66,0,4.35,4.35,0,0,1,1.66,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.42,214a4.35,4.35,0,0,1-1.66,0,4.35,4.35,0,0,1,1.66,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.29,214a4.35,4.35,0,0,1-1.66,0,4.35,4.35,0,0,1,1.66,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.16,214a4.35,4.35,0,0,1-1.66,0,4.35,4.35,0,0,1,1.66,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.1,211.46a3.24,3.24,0,0,1-1.34,0,2.85,2.85,0,0,1,1.34,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.1,208.08a3.24,3.24,0,0,1-1.34,0,2.85,2.85,0,0,1,1.34,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.1,204.7a3.24,3.24,0,0,1-1.34,0,2.85,2.85,0,0,1,1.34,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.1,201.32a3.24,3.24,0,0,1-1.34,0,2.85,2.85,0,0,1,1.34,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.1,197.94a3.24,3.24,0,0,1-1.34,0,2.85,2.85,0,0,1,1.34,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.1,194.56a3.24,3.24,0,0,1-1.34,0,2.85,2.85,0,0,1,1.34,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.1,191.18a3.24,3.24,0,0,1-1.34,0,2.85,2.85,0,0,1,1.34,0Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.28 211.71 392.19 211.44 400.75 208.43 409.4 202.59 418.01 205.44 426.69 199.72 435.38 199.7 435.42 199.72 443.67 205.56 451.67 200.27 451.83 200.51 443.67 205.91 443.58 205.85 435.29 199.99 426.78 200.01 418.06 205.76 409.45 202.91 400.86 208.7 392.28 211.71",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.72 208.62 435.29 202.89 426.6 202.89 417.91 197.16 409.48 197.08 400.87 205.8 392.34 205.8 392.34 205.51 400.75 205.51 409.37 196.79 418 196.87 426.69 202.6 435.38 202.6 443.62 208.21 451.85 193.74 452.1 193.88 443.72 208.62",
    style: {
      fill: "#3B5A76"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "window-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.93,57.45H350.76a8.76,8.76,0,0,1,8.76,8.76V238a12.58,12.58,0,0,1-12.58,12.58H144.66A12.58,12.58,0,0,1,132.08,238V65.3A7.85,7.85,0,0,1,139.93,57.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.27,57.45H352.1a7.1,7.1,0,0,1,7.1,7.1V80.7a0,0,0,0,1,0,0H132.08a0,0,0,0,1,0,0V63.64A6.19,6.19,0,0,1,138.27,57.45Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.2,80.7c0,.14-50.77.26-113.39.26S132.4,80.84,132.4,80.7s50.76-.26,113.41-.26S359.2,80.55,359.2,80.7Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.49,69.58a2.15,2.15,0,1,1-2.15-2.15A2.14,2.14,0,0,1,144.49,69.58Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.33,69.58a2.15,2.15,0,1,1-2.14-2.15A2.14,2.14,0,0,1,151.33,69.58Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.31,69.58a2.15,2.15,0,1,1-2.15-2.15A2.14,2.14,0,0,1,158.31,69.58Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.5,98c0,.14-16.4.26-36.63.26s-36.63-.12-36.63-.26,16.4-.26,36.63-.26S283.5,97.89,283.5,98Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.55,113.48c0,.15-19.63.26-43.83.26s-43.83-.11-43.83-.26,19.62-.26,43.83-.26S249.55,113.34,249.55,113.48Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.55,121.77c0,.15-19.63.26-43.83.26s-43.83-.11-43.83-.26,19.62-.26,43.83-.26S249.55,121.63,249.55,121.77Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.55,130.06c0,.15-19.63.27-43.83.27s-43.83-.12-43.83-.27,19.62-.26,43.83-.26S249.55,129.92,249.55,130.06Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.55,138.36c0,.14-19.63.26-43.83.26s-43.83-.12-43.83-.26,19.62-.27,43.83-.27S249.55,138.21,249.55,138.36Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.55,146.65c0,.14-19.63.26-43.83.26s-43.83-.12-43.83-.26,19.62-.27,43.83-.27S249.55,146.5,249.55,146.65Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.55,169.68c0,.15-19.63.26-43.83.26s-43.83-.11-43.83-.26,19.62-.26,43.83-.26S249.55,169.54,249.55,169.68Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.55,161.33c0,.15-19.63.26-43.83.26s-43.83-.11-43.83-.26,19.62-.26,43.83-.26S249.55,161.19,249.55,161.33Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.63,111.79a23.68,23.68,0,1,0,23.67,23.67A23.68,23.68,0,0,0,305.63,111.79Zm.36,37.86a14.55,14.55,0,1,1,14.54-14.55A14.54,14.54,0,0,1,306,149.65Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.44,135.1a14.54,14.54,0,0,1,8.62-13.28l-3.64-8.18A23.69,23.69,0,0,0,282,135.46q0,.49,0,1h9.53C291.47,136,291.44,135.56,291.44,135.1Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.22,165.11c0,.12-8.77.22-19.59.22s-19.59-.1-19.59-.22,8.77-.23,19.59-.23S325.22,165,325.22,165.11Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.49,168.71c0,.12-4.86.22-10.86.22s-10.87-.1-10.87-.22,4.87-.23,10.87-.23S316.49,168.58,316.49,168.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.92,132v1L302,137.49h-1.68l1.84-4.23h-1.44v.84H299.4V132Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.57,135.74c0,1-.73,1.86-2.38,1.86a4.11,4.11,0,0,1-2.11-.53l.55-1.17a2.76,2.76,0,0,0,1.51.46c.53,0,.88-.21.88-.58s-.23-.55-1.06-.55h-1.48l.27-3.19h3.47v1.19H306l-.07.8h.36C307.94,134,308.57,134.77,308.57,135.74Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.84,133.48a1.4,1.4,0,1,1,1.39,1.51A1.37,1.37,0,0,1,308.84,133.48Zm4.62-1.44h1.12l-3.73,5.45h-1.12Zm-2.77,1.44c0-.55-.19-.77-.46-.77s-.46.22-.46.77.21.77.46.77S310.69,134,310.69,133.48Zm2,2.57a1.4,1.4,0,1,1,1.39,1.51A1.37,1.37,0,0,1,312.69,136.05Zm1.85,0c0-.55-.2-.77-.46-.77s-.46.22-.46.77.2.77.46.77S314.54,136.61,314.54,136.05Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.32,
    y: 217.63,
    width: 6.76,
    height: 15.57,
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.25,
    y: 217.63,
    width: 6.76,
    height: 15.57,
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.79,
    y: 203.45,
    width: 6.76,
    height: 29.75,
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.72,
    y: 203.45,
    width: 6.76,
    height: 29.75,
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.18,
    y: 204.3,
    width: 6.76,
    height: 28.9,
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.11,
    y: 204.3,
    width: 6.76,
    height: 28.9,
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.04,
    y: 204.3,
    width: 6.76,
    height: 28.9,
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.65,
    y: 189.14,
    width: 6.76,
    height: 44.07,
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.58,
    y: 193.45,
    width: 6.76,
    height: 39.75,
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.91,
    y: 204.3,
    width: 6.76,
    height: 28.9,
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.45,
    y: 209.85,
    width: 6.76,
    height: 23.35,
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.89,
    y: 188.88,
    width: 6.76,
    height: 44.32,
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.43,
    y: 209.85,
    width: 6.76,
    height: 23.35,
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.37,
    y: 209.85,
    width: 6.76,
    height: 23.35,
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.51,
    y: 199.54,
    width: 6.76,
    height: 33.66,
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.47,
    cy: 189.14,
    r: 1.74,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.47,192.29a3.16,3.16,0,1,1,3.16-3.15A3.16,3.16,0,0,1,231.47,192.29Zm0-6.06a2.91,2.91,0,1,0,2.9,2.91A2.91,2.91,0,0,0,231.47,186.23Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.86 184.7 232.77 181.28 233.62 181.3 232.03 179.35 230.43 181.31 231.31 181.32 231.4 184.7 232.86 184.7",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62,210.51a1.74,1.74,0,1,1-1.74-1.74A1.74,1.74,0,0,1,176.62,210.51Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.88,213.73a3.16,3.16,0,1,1,3.16-3.15A3.15,3.15,0,0,1,174.88,213.73Zm0-6.06a2.91,2.91,0,1,0,2.91,2.91A2.9,2.9,0,0,0,174.88,207.67Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.84 199.73 173.93 203.29 173.04 203.28 174.7 205.3 176.36 203.26 175.44 203.25 175.35 199.74 173.84 199.73",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.81 192.29 265.9 195.85 265.01 195.84 266.67 197.86 268.33 195.82 267.41 195.81 267.32 192.3 265.81 192.29",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.74,223.81l-20.35-19.09c-12.9-6.23-32.81-15.4-35.13-15.28-2.6.16-52,19.62-70.77,27.11l-.37-.93c2.77-1.1,67.78-27,71.08-27.17h.07c3.61,0,32.33,13.83,35.62,15.41l.12.09L286.9,222.6c3.78-2,25.41-13.41,25.78-13.57.13-.06.47-.2,30.22-.2v1c-11.42,0-28.57,0-29.87.14-1.13.57-17.36,9.13-26,13.68Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.41,203.88a1.74,1.74,0,1,1-1.74-1.74A1.74,1.74,0,0,1,268.41,203.88Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.67,207.1a3.16,3.16,0,1,1,3.16-3.16A3.17,3.17,0,0,1,266.67,207.1Zm0-6.06a2.9,2.9,0,1,0,2.9,2.9A2.9,2.9,0,0,0,266.67,201Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.62,209.06a1.74,1.74,0,1,1-1.74-1.74A1.74,1.74,0,0,1,314.62,209.06Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.88,212.28a3.16,3.16,0,1,1,3.16-3.16A3.17,3.17,0,0,1,312.88,212.28Zm0-6.06a2.91,2.91,0,1,0,2.9,2.9A2.9,2.9,0,0,0,312.88,206.22Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.94 198.73 312.04 202.29 311.15 202.27 312.81 204.3 314.47 202.25 313.55 202.25 313.45 198.74 311.94 198.73",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.51,250.55l.53,0,.67,0,.91-.14a13.24,13.24,0,0,0,2.5-.74,12.9,12.9,0,0,0,3.07-1.88,12,12,0,0,0,2.86-3.54,12.24,12.24,0,0,0,1.38-5.29c0-4,0-8.65,0-13.86,0-20.86-.05-51-.08-88.31,0-18.64,0-39.06,0-61,0-2.74,0-5.51,0-8.29a13.32,13.32,0,0,0-.34-4.1,7.92,7.92,0,0,0-2.14-3.46,7.75,7.75,0,0,0-3.59-2,18.37,18.37,0,0,0-4.22-.24H304.29l-160.37,0c-1.77,0-3.58,0-5.3,0a7,7,0,0,0-6.28,6.92V90.88q0,20.78,0,40.92c0,26.82,0,52.7,0,77.35q0,9.25,0,18.26v8.94a22.55,22.55,0,0,0,.21,4.37,11.82,11.82,0,0,0,8.15,9.1,13.11,13.11,0,0,0,4.18.51h21l61,0,88.31.08,24,.05,6.24,0c1.41,0,2.13,0,2.13,0l-2.13,0-6.24,0-24,0-88.31.09-61,0h-21a13.78,13.78,0,0,1-4.31-.53,12.26,12.26,0,0,1-8.47-9.44,23,23,0,0,1-.22-4.46c0-3,0-5.94,0-8.94V209.15c0-24.65,0-50.53,0-77.35V64.67a7.55,7.55,0,0,1,6.74-7.44c1.83-.09,3.57,0,5.36,0l160.37,0h46.87a9,9,0,0,1,2.18.25,8.33,8.33,0,0,1,3.79,2.08,8.58,8.58,0,0,1,2.26,3.66,14.17,14.17,0,0,1,.35,4.23v8.29c0,21.92,0,42.34,0,61,0,37.28-.07,67.45-.09,88.31,0,5.21,0,9.85,0,13.86a12,12,0,0,1-4.33,8.91,12.77,12.77,0,0,1-3.1,1.87,12.45,12.45,0,0,1-2.52.72l-.92.13-.67,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.83,
    cy: 155.72,
    r: 10.51,
    transform: "translate(126.7 471.37) rotate(-76.78)",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.32,155.72a20.29,20.29,0,0,0,.42,2.54,10.35,10.35,0,0,0,13.58,7.11,10.23,10.23,0,0,0,4.77-3.59,10.22,10.22,0,0,0,0-12.12,9.55,9.55,0,0,0-2.17-2.18,9.25,9.25,0,0,0-2.6-1.4,10.29,10.29,0,0,0-9.74,1.43,10.51,10.51,0,0,0-3.84,5.67,21,21,0,0,0-.42,2.54,7.82,7.82,0,0,1,.23-2.59,10.41,10.41,0,0,1,3.8-5.91,10.67,10.67,0,0,1,10.14-1.59,10,10,0,0,1,2.73,1.45,10.49,10.49,0,0,1,2.28,2.28,10.7,10.7,0,0,1,0,12.73,10.49,10.49,0,0,1-2.28,2.28,10.27,10.27,0,0,1-2.73,1.45,10.69,10.69,0,0,1-5.64.44,10.62,10.62,0,0,1-8.3-7.95A7.82,7.82,0,0,1,350.32,155.72Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.23,158.7a.5.5,0,0,1-.3-.89l2.7-2.11-2.73-2.06a.5.5,0,0,1-.09-.7.5.5,0,0,1,.7-.1l3.24,2.46a.5.5,0,0,1,.2.39.51.51,0,0,1-.19.4l-3.22,2.51A.5.5,0,0,1,359.23,158.7Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.38,
    cy: 156.36,
    r: 10.51,
    transform: "translate(-51.66 247.52) rotate(-76.78)",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.89,156.36a21.94,21.94,0,0,0-.43-2.54,10.44,10.44,0,0,0-3.84-5.67,10.18,10.18,0,0,0-4.34-1.9,10.31,10.31,0,0,0-5.4.46,9.94,9.94,0,0,0-2.6,1.4,9.77,9.77,0,0,0-2.16,2.19,10.22,10.22,0,0,0,0,12.12,9.72,9.72,0,0,0,2.16,2.18,9.39,9.39,0,0,0,2.6,1.4,10.31,10.31,0,0,0,5.4.47,10.18,10.18,0,0,0,4.34-1.9,10.51,10.51,0,0,0,3.84-5.67,22.76,22.76,0,0,0,.43-2.54,8.19,8.19,0,0,1-.23,2.59,10.58,10.58,0,0,1-8.3,7.94,10.71,10.71,0,0,1-5.65-.43,10.82,10.82,0,0,1-5-3.74,10.66,10.66,0,0,1,0-12.73,10.07,10.07,0,0,1,2.28-2.28,10.21,10.21,0,0,1,2.72-1.45,10.82,10.82,0,0,1,5.65-.44,10.67,10.67,0,0,1,4.49,2,10.46,10.46,0,0,1,3.81,5.91A8.19,8.19,0,0,1,140.89,156.36Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,159.34a.47.47,0,0,1-.3-.1l-3.25-2.46a.5.5,0,0,1-.2-.39.49.49,0,0,1,.2-.4l3.21-2.51a.5.5,0,1,1,.61.79l-2.7,2.11,2.73,2.06a.5.5,0,0,1-.3.9Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "plant",
    "data-motion": "sway",
    "data-delay": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.71,424c13.33-5.66,28.77-16.79,35.65-30.44A75.86,75.86,0,0,0,420.71,424",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.55,402.83c13.33-5.66,28.76-16.8,35.65-30.45a75.93,75.93,0,0,0-35.65,30.45",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.4,382.22c13.34-5.66,28.77-16.79,35.66-30.44a75.94,75.94,0,0,0-35.66,30.44",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.24,360.65c12.58-7.46,26.6-20.64,31.82-35.11a78.4,78.4,0,0,0-31.82,35.11",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.41,344.14c9.16-12,17.71-29.82,17.59-45.28a84.24,84.24,0,0,0-17.59,45.28",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.84,352C433,335.78,426.69,315.4,416,303.24A99,99,0,0,0,434.84,352",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.54,369.72c-3.27-16.71-11.52-37.38-23.67-49.1a102.8,102.8,0,0,0,23.67,49.1",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.58,391.34c-3.26-16.71-11.51-37.38-23.66-49.1a102.88,102.88,0,0,0,23.66,49.1",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.61,417.89c-3.26-16.71-11.51-37.38-23.66-49.11a102.91,102.91,0,0,0,23.66,49.11",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,341s0,.08-.1.25-.15.44-.26.74l-.92,2.9c-.8,2.51-1.89,6.17-3.16,10.71s-2.68,10-4.13,16-2.87,12.77-4.21,19.84-2.4,13.84-3.28,20-1.51,11.75-2,16.44-.79,8.49-.95,11.12c-.08,1.29-.15,2.3-.19,3,0,.32,0,.58,0,.79a.7.7,0,0,0,0,.27s0-.09,0-.27.06-.46.09-.78c.07-.73.17-1.74.29-3,.23-2.63.6-6.42,1.12-11.1s1.2-10.25,2.08-16.42,2-12.92,3.31-20,2.77-13.76,4.17-19.83,2.79-11.5,4-16,2.25-8.22,3-10.75l.83-2.91c.09-.32.15-.57.21-.77A1,1,0,0,0,438,341Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.21,432.84c5.66-11.84,9.77-28.49,7-41.49a73.63,73.63,0,0,0-7,41.49",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.81,417.51c5.65-11.85,9.77-28.49,7-41.49a73.55,73.55,0,0,0-7,41.49",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.38,401.92c5.65-11.85,9.76-28.49,7-41.49a73.55,73.55,0,0,0-7,41.49",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.07,385.1c4.2-12.53,6.31-29.61,2-42.11a74,74,0,0,0-2,42.11",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.66,371.34c-.41-13.34-4.34-30-12.62-39.88a72.33,72.33,0,0,0,12.62,39.88",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.16,378c-9.81-9.26-24.72-18.45-38.13-19.65A74,74,0,0,0,385.16,378",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.77,392c-11-8.71-27.32-16.88-41.43-16.91A77,77,0,0,0,391.77,392",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,408.89c-11-8.71-27.32-16.89-41.44-16.92A76.89,76.89,0,0,0,400,408.89",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.55,428.36c-11-8.71-27.32-16.89-41.43-16.92a76.86,76.86,0,0,0,41.43,16.92",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.38,368.92s0,.07.06.22l.22.62c.23.59.54,1.39.92,2.4.8,2.08,2,5.07,3.6,8.73,3.14,7.33,7.78,17.33,13.56,28.05,2.89,5.35,5.79,10.38,8.51,14.9s5.27,8.51,7.49,11.83,4,6,5.34,7.79l1.5,2.08.4.54a1.07,1.07,0,0,0,.15.17s0-.08-.11-.2l-.36-.57-1.43-2.13c-1.25-1.84-3-4.53-5.2-7.87s-4.68-7.37-7.39-11.88-5.57-9.55-8.47-14.9C394.41,398,389.72,388,386.5,380.75c-1.61-3.64-2.88-6.6-3.74-8.66l-1-2.36c-.11-.25-.2-.45-.28-.61A.88.88,0,0,0,381.38,368.92Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.29 434.27 443.46 434.27 443.46 445.09 437.69 445.09 432.83 475.97 398.1 475.97 393.1 445.09 387.29 445.09 387.29 434.27",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.29,444.87c0-.15,12.48-.26,27.88-.26s27.89.11,27.89.26-12.49.26-27.89.26S387.29,445,387.29,444.87Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "character",
    "data-motion": "breathe",
    "data-delay": 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.72,333.21a32.31,32.31,0,0,0,6.78-.36,15.54,15.54,0,0,0,4.53-2s4.93.68,5.72-.42a4.2,4.2,0,0,0,.74-2.36l3.62-.45,3.28.62,1.81,2.21s1.36,0,1.42-.82c0,0,1.81-.82,1.64-1.39s-1.17-3.28-1.17-3.28L191.71,322s-8.94-.56-9.28-.34-11.66,5.5-11.66,5.5l-4.19,1Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.36,318.6l14.18-3.18,9.9-.53s8.44,3.92,8.2,7.43l1.77.95s-.15,2.62-2.26,2a20.9,20.9,0,0,1-3-1.12l2.27,3.46a3.29,3.29,0,0,1-3.13.06c-.71-.34-5.69-4.11-5.69-4.11l-4.21-.12s-7.82,5.38-11.45,6-9.81-.66-9.81-.66Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.15,325.31c0-.06.36.06.94,0a1.2,1.2,0,0,0,.79-.59,2.45,2.45,0,0,0,.24-1.34l.08.14-6.12-4-1.84-1.2c-.57-.37-1.21-.8-1.67-1,0,0,0,0,0,0h-.83l-.91,0-1.63,0a20,20,0,0,1-3.21-.09,18.91,18.91,0,0,1,3.18-.28l1.6-.08.9,0,.47,0h.35a.85.85,0,0,1,.22,0,18,18,0,0,1,1.83,1.08l1.85,1.2c2.36,1.57,4.49,3,6,4.15l.08.06v.09a2.68,2.68,0,0,1-.36,1.53,1.37,1.37,0,0,1-1,.64,1.72,1.72,0,0,1-.74-.07C201.23,325.36,201.15,325.33,201.15,325.31Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.27,327.42a9.93,9.93,0,0,1-1.48-1.72c-.87-1.1-2-2.65-3.31-4.38l.05,0-.17-.13c-.43-.33-.86-.65-1.28-.93l-.64-.39a1.74,1.74,0,0,0-.62-.2,20.58,20.58,0,0,0-2.48-.25,11.9,11.9,0,0,1-2.33-.18,8.71,8.71,0,0,1,2.34-.19,16.09,16.09,0,0,1,2.56.14,2.54,2.54,0,0,1,.77.24c.23.12.45.26.67.4.45.29.89.61,1.33.95l.17.14,0,0,0,0c1.27,1.74,2.39,3.32,3.18,4.48A10,10,0,0,1,200.27,327.42Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.75,433.51l.33,26.24s26.66,6.58,27.2,11.42l-50.74,4.37-2.19-40.87Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.25,458.31a2.08,2.08,0,0,0-1.32,2.44,2,2,0,0,0,2.41,1.33,2.19,2.19,0,0,0,1.38-2.59,2.08,2.08,0,0,0-2.66-1.11",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.54,475.54l-.22-4.12,49.14-2.51a3.5,3.5,0,0,1,2.1,2.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.89,459.45c0,.25-1.23.42-2.41,1.28s-1.79,1.94-2,1.85S252.53,461,254,460,256.94,459.22,256.89,459.45Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.34,461.4c.06.24-1,.71-1.78,1.8s-1,2.22-1.23,2.22-.48-1.4.53-2.73S262.32,461.16,262.34,461.4Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.67,467.64c-.22.06-.62-1.16-.05-2.55s1.7-2,1.82-1.79-.57,1-1,2.11S265.92,467.6,265.67,467.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.16,453.48c-.1.23-1.25-.05-2.65.11s-2.47.66-2.61.45.87-1.14,2.52-1.31S256.27,453.28,256.16,453.48Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "255.81 438.71 255.88 443.38 230.97 446.05 230.63 440.16 255.81 438.71"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M256,448.19a4.84,4.84,0,0,1-2.55.11,11.66,11.66,0,0,1-2.7-.69,11.92,11.92,0,0,1-1.5-.71,3,3,0,0,1-.8-.56,1.08,1.08,0,0,1-.18-1.31,1.34,1.34,0,0,1,1.06-.62,3.59,3.59,0,0,1,1,.08,9,9,0,0,1,4,1.9c1.23,1,1.68,1.94,1.6,2s-.72-.66-2-1.5a10.12,10.12,0,0,0-2.33-1.17,8.55,8.55,0,0,0-1.49-.38c-.54-.12-1-.1-1.13.15,0,.09-.05.13.07.28a2.73,2.73,0,0,0,.59.41,13.79,13.79,0,0,0,1.38.7,14.09,14.09,0,0,0,2.51.83A15.72,15.72,0,0,1,256,448.19Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.69,448.56a4,4,0,0,1-.8-2.43,8.25,8.25,0,0,1,.22-2.8,8.61,8.61,0,0,1,.57-1.58,2.12,2.12,0,0,1,1.56-1.37,1.19,1.19,0,0,1,1.1.66,3.56,3.56,0,0,1,.31.92,5.6,5.6,0,0,1,.08,1.72,5.68,5.68,0,0,1-1,2.68c-.93,1.37-1.95,1.72-2,1.63s.75-.64,1.45-1.94a5.89,5.89,0,0,0,.69-2.43,5.25,5.25,0,0,0-.12-1.47c-.11-.54-.33-1-.53-.9s-.66.43-.85.88a8,8,0,0,0-.56,1.41,8.93,8.93,0,0,0-.37,2.56C255.51,447.6,255.82,448.52,255.69,448.56Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.68,343.48s82.6-13.71,86.28-14.28c14.16-2.18,30.32-.45,35.71,9.71a76.12,76.12,0,0,1,4.77,23.46c.68,12.49,5.64,86.48,5.64,86.48L227,454.52l-11.22-81.87h0l-19.24,3.61c1.08-.13-50,9-65.42,10.61-11.91,1.21-25.64-5.21-28.38-15.83-1.8-6.94-5.71-26.26-5.71-26.26Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.85,361.34a45.22,45.22,0,0,0-4.57,5.09,47.36,47.36,0,0,0-3.3,6,6.23,6.23,0,0,1,.55-2,19.52,19.52,0,0,1,2.33-4.32,20.29,20.29,0,0,1,3.31-3.63A6.16,6.16,0,0,1,223.85,361.34Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.35,203.37A11.64,11.64,0,0,0,56.67,210c0,2.27,1.56,6.87,5.58,7.1-1.07,6.49,3.09,11.28,10,11.29s14.83-11.85,21.24-14.45l18.6-4.92c1.63-.38,2.3-2.37,2.27-4s-.46-3.42.13-5c.81-2.15,3.31-3.3,4.16-5.44,1-2.43-.53-5.13-2.26-7.09s-3.83-3.83-4.38-6.38c-.51-2.35.4-5-.78-7.1-1.44-2.58-5.23-2.91-7-5.28-.85-1.16-1.12-2.66-2-3.82-1.43-2-4.19-2.49-6.62-2.23s-4.76,1.15-7.19,1.33c-3.34.24-6.79-.84-10,.13-3.54,1.06-5.69,4.2-8,7.24l-3,3.52a13.49,13.49,0,0,1-2,1.63,24,24,0,0,0-3.79,2.43,5.91,5.91,0,0,0,.41,8.52,6.29,6.29,0,0,0-4.24,6.21s-.33,3.08,1.62,4.45A4.25,4.25,0,0,0,58.35,203.37Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.81,209.66a85.44,85.44,0,0,1-3.75-14.38,30.05,30.05,0,0,1,1.18-14.68c.26-.7,2.5-5.43,3.24-5.36.54.06-.84,4.47-.57,4.93,2.58,4.43,3.29,9.77,2.87,14.88a67,67,0,0,1-3,14.61",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.06,252.93c-11-1.38-12.24-19-12.24-19l-.5-43.18c-.4-12.43,6.5-23,18.94-23.09l1.15.06a22.23,22.23,0,0,1,21,21.6c.29,10.78.47,22.7.09,28.45-.78,11.91-12.8,13.13-12.8,13.13s-.32,10.69-.28,14.37c.13,12.68-12.32,7.94-15.4,7.67Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.74,230.89a28.84,28.84,0,0,1-15.28-5.42s3.21,9.38,15.17,8.94Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.31,199.09a1.7,1.7,0,0,1-1.73,1.63,1.63,1.63,0,0,1-1.67-1.63,1.7,1.7,0,0,1,1.73-1.63A1.63,1.63,0,0,1,108.31,199.09Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.64,194.13c-.23.21-1.46-.82-3.3-.91s-3.22.75-3.41.51.15-.49.76-.88a4.59,4.59,0,0,1,2.74-.69,4.52,4.52,0,0,1,2.61,1C108.58,193.62,108.75,194,108.64,194.13Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.09,199.09a1.7,1.7,0,0,1-1.73,1.63,1.63,1.63,0,0,1-1.67-1.63,1.7,1.7,0,0,1,1.73-1.63A1.63,1.63,0,0,1,91.09,199.09Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.66,193.9c-.23.22-1.47-.81-3.3-.9s-3.22.75-3.41.51.14-.49.75-.88a4.62,4.62,0,0,1,2.75-.69,4.52,4.52,0,0,1,2.61,1C90.59,193.4,90.76,193.81,90.66,193.9Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.47,208.33a12.35,12.35,0,0,1,3-.37c.47,0,.91-.1,1-.41a2.38,2.38,0,0,0-.24-1.41c-.38-1.15-.77-2.36-1.19-3.63-1.65-5.18-2.82-9.42-2.61-9.48s1.72,4.07,3.37,9.25c.39,1.27.77,2.49,1.13,3.65a2.68,2.68,0,0,1,.14,1.85,1.16,1.16,0,0,1-.8.64,3,3,0,0,1-.8.07A11.61,11.61,0,0,1,96.47,208.33Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,209.31c.3,0,.2,2,1.82,3.49s3.76,1.4,3.76,1.68c0,.12-.49.36-1.39.33a4.91,4.91,0,0,1-3.14-1.28,4.31,4.31,0,0,1-1.4-2.92C90.63,209.77,90.88,209.29,91,209.31Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,186.47c-.2.48-2,.15-4.18.29s-3.94.64-4.2.18c-.11-.22.21-.67.94-1.12a7.28,7.28,0,0,1,6.39-.36C90.67,185.82,91,186.23,91,186.47Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.21,188c-.35.39-1.59-.1-3.1-.21s-2.82.13-3.09-.32c-.12-.22.1-.62.69-1a4.27,4.27,0,0,1,2.55-.54,4.22,4.22,0,0,1,2.43,1C108.21,187.36,108.36,187.8,108.21,188Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.82,199.62c-.2-.1-8.06-2.86-8.24,5.3s8.06,6.66,8.08,6.42S70.82,199.62,70.82,199.62Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.23,208.2s-.14.09-.39.2a1.46,1.46,0,0,1-1.06,0c-.86-.34-1.55-1.72-1.56-3.2a4.83,4.83,0,0,1,.44-2,1.63,1.63,0,0,1,1.1-1.07.72.72,0,0,1,.83.41c.1.23,0,.39.09.4s.18-.13.12-.47a.91.91,0,0,0-.31-.52,1.07,1.07,0,0,0-.78-.22,2,2,0,0,0-1.52,1.23,5,5,0,0,0-.54,2.27c0,1.64.83,3.2,2,3.57a1.51,1.51,0,0,0,1.3-.19C68.21,208.39,68.26,208.21,68.23,208.2Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.34,175.72c1.33-.71-2.58-5-5.81-6.56-4.88-2.28-12.35-3.75-16.89-2.53-5.47,1.48-10,4.13-12.83,9.05A32.19,32.19,0,0,0,67,192a9.87,9.87,0,0,0,1.09,5c1.12,1.82,3.29,3,3.16,5.47a3.46,3.46,0,0,0,.82,2.5c1.47,1.61,3.32.14,4.18-1.34,1.84-3.18,2.08-7,2.29-10.66a24.08,24.08,0,0,0-.42-7.77c-.38-1.36-1-2.66-1.31-4a4.91,4.91,0,0,1,.63-4.07,5.25,5.25,0,0,1,.67-.66,8.52,8.52,0,0,1,8.47-1.5c4.58,1.68,12.4,4.21,14.47,2.68,3-2.21,3.7-3.66,3.7-3.66Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.08,165.53a18,18,0,0,1,13.78.93,9.36,9.36,0,0,1,4.85,5.49c.65,2.42-.42,5.39-2.76,6.3l-.16.1c-3.49,1.13-5.75.63-9.21-.61-2.91-1.05-5.49-2.89-8.4-3.92a16.58,16.58,0,0,0-9.71-.41A27.08,27.08,0,0,1,84.08,165.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.55,173.6c.07.06.73-.72,2.06-1.64a11.8,11.8,0,0,1,2.47-1.32,7.52,7.52,0,0,1,3.32-.56,11,11,0,0,1,5.69,2.35c1.27,1,1.85,1.84,1.93,1.78s-.09-.25-.36-.63a8.68,8.68,0,0,0-1.32-1.45,10.58,10.58,0,0,0-5.89-2.59,7.66,7.66,0,0,0-3.55.63,10.54,10.54,0,0,0-2.52,1.48A6.45,6.45,0,0,0,68.55,173.6Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.43,164.79a21.9,21.9,0,0,0,2.16.81,17.85,17.85,0,0,1,8.38,6.9c.76,1.19,1.13,2,1.21,2a6.27,6.27,0,0,0-.88-2.17,15.4,15.4,0,0,0-8.58-7.06A6.36,6.36,0,0,0,93.43,164.79Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.26,224l-1.44,6.21L101.29,251l-1.5-10.36a51.41,51.41,0,0,0-10.21-8.11A97.92,97.92,0,0,0,69.26,224Z",
    style: {
      fill: "#F0F5FA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.57,232s-10.3,21.83-11,30.12S57.65,298,57.65,298l46.46,53,46.37,3.08s-21.95-46.16-26.86-55.16-21.42-49.79-21.42-49.79a25.67,25.67,0,0,0-5.82-9c-6.29-6.67-18.49-10.78-29.47-13Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.26,241.32c6.89.81,15.74,6,18.81,18.11l3,15,14.85,30.14,48.65,13.88-6.32,19.06S115,333.68,108.75,332s-32.19-38.47-32.19-38.47-13-22.41-9.65-38.92C68.57,246.37,75.76,240.32,84.26,241.32Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.26,241.32l-1.16,0a17.28,17.28,0,0,0-3.39.25,15.63,15.63,0,0,0-5.1,2,16.21,16.21,0,0,0-5.23,5.24,17.65,17.65,0,0,0-1.84,4,10.44,10.44,0,0,0-.31,1.13,7.71,7.71,0,0,0-.24,1.18c-.11.81-.22,1.63-.34,2.47a42.86,42.86,0,0,0,.71,11,71,71,0,0,0,3.49,12.13,96.48,96.48,0,0,0,5.9,12.78h0c3.76,5.29,7.85,10.87,12.25,16.64a220,220,0,0,0,14.51,17.48A24.23,24.23,0,0,0,108,331.4a8.52,8.52,0,0,0,2.81.77c1,.15,2,.32,3,.43,4,.53,8.17.95,12.36,1.37,8.36.82,17,1.58,25.74,2.32l11.34.92-.26.18q3.21-9.72,6.31-19.06l.18.33-48.64-13.91-.1,0,0-.09-14.81-30.17v0q-1-4.94-1.83-9.37a59.9,59.9,0,0,0-1.9-8.24,23.88,23.88,0,0,0-7.53-10.94A21.34,21.34,0,0,0,87.14,242a20.28,20.28,0,0,0-2.14-.49l-.74-.14s.26,0,.75.09a16.38,16.38,0,0,1,2.16.44,21.07,21.07,0,0,1,7.54,3.86,24.07,24.07,0,0,1,7.67,11,58.7,58.7,0,0,1,2,8.27q.89,4.42,1.87,9.36l0,0,14.89,30.12-.14-.11,48.66,13.85.25.07-.08.25q-3.09,9.33-6.31,19.07l-.07.19-.2,0-11.34-.92c-8.78-.75-17.38-1.5-25.75-2.33-4.19-.42-8.32-.85-12.37-1.38-1-.11-2-.28-3-.43-.5-.07-1-.19-1.5-.29a4.07,4.07,0,0,1-1.48-.54,25,25,0,0,1-4.56-3.93,218.06,218.06,0,0,1-14.53-17.54c-4.39-5.78-8.47-11.37-12.23-16.68h0a97,97,0,0,1-5.89-12.85A71.55,71.55,0,0,1,67,268.61a42.89,42.89,0,0,1-.67-11.07c.12-.85.24-1.69.35-2.5a7.88,7.88,0,0,1,.26-1.19,10.2,10.2,0,0,1,.32-1.15,17.71,17.71,0,0,1,1.89-4.07,16.21,16.21,0,0,1,5.33-5.26,15.58,15.58,0,0,1,5.17-2,15.31,15.31,0,0,1,3.42-.19C83.87,241.27,84.26,241.32,84.26,241.32Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.52,316.21a7,7,0,0,1,.76-2,28.18,28.18,0,0,1,2.66-4.44,28.49,28.49,0,0,1,3.43-3.88,7,7,0,0,1,1.68-1.33c.11.12-2.34,2.29-4.69,5.52S112.67,316.28,112.52,316.21Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,253a10.49,10.49,0,0,1-1.18-1.24c-.36-.42-.8-.92-1.35-1.47s-1.14-1.21-1.88-1.87A54.65,54.65,0,0,0,94.33,244a62.85,62.85,0,0,0-7.12-4.49A78.46,78.46,0,0,0,73,233.78c-1.88-.56-3.42-1-4.48-1.25a9.87,9.87,0,0,1-1.64-.49,11.55,11.55,0,0,1,1.69.29c1.08.21,2.63.58,4.53,1.09A70.72,70.72,0,0,1,87.45,239a57.76,57.76,0,0,1,7.16,4.56,49.31,49.31,0,0,1,5.23,4.55c.72.67,1.3,1.36,1.83,1.93s1,1.1,1.3,1.54A11,11,0,0,1,104,253Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.53,266.49a1.68,1.68,0,0,0-2.09,1.13L227.52,324.2,170.84,333a3.36,3.36,0,0,0-2.8,3.83l62.09-9.68h0v0l17.51-58.58A1.68,1.68,0,0,0,246.53,266.49Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.53,266.49a1.59,1.59,0,0,1,.95.67,1.74,1.74,0,0,1,.23,1.41l-.55,1.91-3.65,12.44-13.15,44.3v-.06l0,.22-.23,0h0l.18-.16h0l-.07.22-.21-.07h.09L169.24,337l-1.16.18-.25,0,0-.26a3.62,3.62,0,0,1,2-3.81,3.81,3.81,0,0,1,1.09-.33l1.05-.16,2.09-.33,8.29-1.29,16-2.49L227.49,324l-.18.16c5.34-17.73,9.78-32.49,12.9-42.84l3.65-12q.31-1,.57-1.83a1.72,1.72,0,0,1,1-1,1.54,1.54,0,0,1,1.13,0,1.85,1.85,0,0,0-1.1.09,1.63,1.63,0,0,0-.9.95q-.24.8-.54,1.83l-3.53,12c-3.07,10.36-7.46,25.14-12.72,42.89l0,.13-.14,0L198.39,329l-16,2.5-8.29,1.29-2.09.33a7.61,7.61,0,0,0-2,.45,3.11,3.11,0,0,0-1.72,3.26l-.3-.21,1.16-.18L230.09,327h0l.05,0h0l-.28.15h0l0-.14.14,0h0l-.19.26v-.09l0,0c5.5-18.29,10.1-33.55,13.32-44.26,1.62-5.33,2.9-9.52,3.78-12.4l.58-1.9a1.68,1.68,0,0,0-.19-1.34A1.92,1.92,0,0,0,246.53,266.49Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.14,327.19c-.12.08-.72-.62-1.46-1.46s-1.33-1.55-1.23-1.66.87.44,1.63,1.32S230.26,327.11,230.14,327.19Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.79,326.34c0-.06.25-.25.65,0a.75.75,0,0,1,.4.7.85.85,0,0,1-1.56.43.76.76,0,0,1-.07-.8c.24-.42.6-.35.58-.29s-.19.17-.24.43a.44.44,0,0,0,.52.5.41.41,0,0,0,.29-.32.36.36,0,0,0-.13-.34C221,326.4,220.82,326.4,220.79,326.34Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.41,325.78c0-.06.25-.25.65,0a.74.74,0,0,1,.4.7.86.86,0,0,1-.63.77.89.89,0,0,1-.93-.34.76.76,0,0,1-.07-.8c.25-.42.6-.36.58-.3s-.19.18-.24.43a.41.41,0,0,0,.11.37.44.44,0,0,0,.41.14.43.43,0,0,0,.29-.32.36.36,0,0,0-.13-.35C224.64,325.85,224.44,325.85,224.41,325.78Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.57 400.3 61.56 475.89 69.95 475.97 101.04 399.51 84.57 400.3",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.52,390c-.06,0,26,85.76,26,85.76l8.32.12L201.8,388.28Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.61,280.21a8.88,8.88,0,0,0-9.49-1.65c-6.45,2.75-15.89,8.39-13.77,17.3C28,307,58.5,379.66,68.34,403a11.67,11.67,0,0,0,10.84,7.13L207,409.05a9.45,9.45,0,0,0,9.28-10.67l-4.78-36.3a25.87,25.87,0,0,0-23.36-22.39l-82.66-7.34Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.16,391.71a1.23,1.23,0,0,1-.07-.27c0-.2-.09-.45-.16-.77-.14-.72-.33-1.72-.57-3-.47-2.64-1.15-6.38-2-11s-1.8-10.19-2.88-16.33c-.53-3.07-1.1-6.3-1.68-9.64-.29-1.68-.59-3.38-.89-5.11a13.72,13.72,0,0,1-.14-5.39A6.23,6.23,0,0,1,57,337.72,7.16,7.16,0,0,1,59.19,336a15.63,15.63,0,0,1,5-1.43c3.4-.38,6.66-.57,9.78-.8,6.23-.43,11.84-.71,16.56-.9s8.54-.27,11.18-.31l3,0h.79l.27,0a1.14,1.14,0,0,1-.27,0l-.79,0-3,.12-11.16.48c-4.72.23-10.33.55-16.55,1-3.1.24-6.39.45-9.74.83a14.91,14.91,0,0,0-4.87,1.38,5.86,5.86,0,0,0-3.13,3.84,13.16,13.16,0,0,0,.15,5.19q.44,2.6.87,5.1.87,5,1.65,9.65c1,6.15,2,11.68,2.77,16.35s1.39,8.38,1.82,11c.2,1.27.36,2.28.47,3,0,.32.08.58.11.79A1.08,1.08,0,0,1,64.16,391.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.48,388.28c0,.14-33,.26-73.73.26S63,388.42,63,388.28s33-.26,73.74-.26S210.48,388.14,210.48,388.28Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.85,333.51c-.11.1-10.2-11.51-22.54-25.92s-22.26-26.17-22.15-26.27,10.2,11.51,22.54,25.93S79,333.42,78.85,333.51Z",
    style: {
      fill: "#17324A"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecords);
export default __webpack_public_path__ + "static/media/records.edade88f1e52def4c02bc7356b59ba89.svg";
export { ForwardRef as ReactComponent };